import React from "react";

/**
 * Interfaz con las props del switch.
 */
interface GenericSwitchProps {
    /**
     * El estado actual del switch (encendido/apagado).
     */
    checked: boolean;
    /**
     * Función que se dispara cuando se hace toggle.
     * Aquí devolvemos el nuevo estado (true/false).
     */
    onChange: (newChecked: boolean) => void;

    /**
     * Deshabilita el switch para que no sea clickable.
     */
    disabled?: boolean;

    /**
     * Clase adicional para personalizar estilos via Tailwind.
     */
    className?: string;
}

/**
 * Componente Switch genérico, estilo Tailwind, 
 * sin texto embebido (clic sólo en el “toggle”).
 */
const GenericSwitch: React.FC<GenericSwitchProps> = ({
    checked,
    onChange,
    disabled = false,
    className = "",
}) => {
    const handleToggle = () => {
        if (!disabled) {
            onChange(!checked);
        }
    };

    return (
        <div
            className={`relative inline-flex items-center 
        ${disabled ? "cursor-not-allowed" : "cursor-pointer"} 
        ${className}`}
            onClick={handleToggle}
        >
            {/* Input invisible para accesibilidad */}
            <input
                type="checkbox"
                className="sr-only"
                checked={checked}
                onChange={() => { /* no-op, manejamos manual con handleToggle */ }}
                disabled={disabled}
            />
            {/* Track */}
            <div
                className={`
          w-11 h-6 
          rounded-full 
          transition-colors duration-200
          ${checked ? "bg-[var(--color-primitive-brand-surf-700)]" : "bg-gray-300"}
          ${disabled ? "opacity-50" : ""}
        `}
            />
            {/* Thumb (la bolita) */}
            <span
                className={`
          absolute top-[2px] left-[2px]
          w-5 h-5 bg-white rounded-full
          transition-all duration-200
          ${checked ? "translate-x-5" : "translate-x-0"}
        `}
            />
        </div>
    );
};

export default GenericSwitch;
